import { CategoryProgram } from "./category";
import { SEO } from "./seo";

export class Program {
    id?: any;
    title?: any;
    subtitle?: any;
    image?: any;
    description?: any;
    price?: any;
    discountPercentage?: any;
    externalLink?: any;
    jsonContent?: any;
    isValid?: any;
    startPublicationDate?: any;
    isPublished?: boolean;
    isComingSoon?: boolean;

    idSeoFk?: any;

    seo?: SEO;
    categoryPrograms?: CategoryProgram[];

}